module.exports = __webpack_public_path__ + "DINNextLTPro-Italic.eot?2138715e9eb4c15f4462ff7e670d42e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Italic.eot
// module id = 311
// module chunks = 0